import * as React from "react";
import ViewProvider from "search-filter/contexts/ViewProvider";
import ParametersProvider from "search-filter/contexts/ParametersProvider";
import HandlerContextProvider from "search-filter/contexts/HandlerContextProvider";
import SearchFilterBar from "search-filter/components/search-filter-bar/SearchFilterBar";
const SearchPageSearchFilterBar = ({ isParentMutable = true }) => /* @__PURE__ */ React.createElement(ViewProvider, null, /* @__PURE__ */ React.createElement(ParametersProvider, null, /* @__PURE__ */ React.createElement(HandlerContextProvider, null, /* @__PURE__ */ React.createElement(SearchFilterBar, { isParentMutable }))));
export default SearchPageSearchFilterBar;
